export const dummyImgSrc = '/img/v2/components/position/positionDummyImg.png';
